import { redirect } from "@tanstack/react-router";
import { getDefaultStore } from "jotai";

import { returnToAtom } from "@/lib/atoms/return-to-atom";
import { isInternalPath } from "@/lib/utils/is-internal-path";

export const redirectToReturnToOrFallback = (fallback: string): void => {
  const store = getDefaultStore();
  const returnTo = store.get(returnToAtom);

  if (returnTo) {
    store.set(returnToAtom, null);

    if (isInternalPath(returnTo)) {
      redirect({ to: returnTo, throw: true });
    }
  }

  redirect({ to: fallback, throw: true });
};
